import React from "react";


class MultiValueTextInput extends React.Component {
  onRemove(removedIndex) {
    const { textFields, handleMultiTextField } = this.props;

    const withoutRemovedValue = textFields.filter(
      (_, index) => index !== removedIndex
    );
    handleMultiTextField(withoutRemovedValue);
  }

  render() {
    const { textFields, handleMultiTextField } = this.props;

    return (
      <div
        style={{ display: "flex", flexDirection: "column", gap: "8px" }}
      >
        <div style={{ display: "flex", gap: "8px" }}>
          {!textFields?"":textFields.map((item, index) => (
            <div
              style={{
                backgroundColor: "black",
                display: "flex",
                alignItems: "center",
                position: "relative",
                gap: "5px"
              }}
            >
              <span
                style={{
                  color: "white",
                  padding: "8px 0px 8px 16px"
                }}
                key={index}
              >
                {item}
              </span>

              <img
                onClick={() => this.onRemove(index)}
                style={{
                  padding: "5px",
                  background: "transparent",
                  cursor: "pointer",
                  width: "20px",
                  alignSelf: "flex-start"
                }}
                src="https://img.icons8.com/ios-glyphs/30/FFFFFF/delete-sign.png"
                alt="remove"
              />
            </div>
          ))}
        </div>

        <input
          type="text"
          className="form-control"
          onKeyPress={(e) => {
            if (e.key === "Enter") {
              handleMultiTextField([...textFields, e.target.value]);
              e.target.value = "";
            }
          }}
          id="exampleFormControlInput1"
          placeholder="Enter here..."
        />
      </div>
    );
  }
}

export default MultiValueTextInput;